import { alpha, Box, IconButton, keyframes, Stack, Typography } from '@mui/material';
import { CloseIcon, colors } from '@silbo/ui';
import { useTranslation } from 'react-i18next';
import faceWink from '../assets/images/face-wink.svg';

type RewardToastProps = {
  title: string;
  message: string;
  onClose: () => void;
};

const pop = keyframes`
  0% { transform: scale(0.6); }
  60% { transform: scale(1.12); }
  100% { transform: scale(1); }
`;

const RewardToast = ({ title, message, onClose }: RewardToastProps) => {
  const { t } = useTranslation('environmental-cleaning');
  return (
    // Le visage déborde du haut de la carte : la marge laisse la place de le voir en entier.
    <Box sx={{ position: 'relative', width: 'calc(100vw - 32px)', maxWidth: 420, paddingTop: 3 }}>
      <Box
        component="img"
        src={faceWink}
        alt=""
        sx={{
          position: 'absolute',
          top: -8,
          left: 10,
          width: 72,
          height: 74,
          animation: `${pop} 0.45s ease-out`,
          '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
        }}
      />
      <Stack
        direction="row"
        alignItems="center"
        gap={3}
        sx={{
          minHeight: 76,
          paddingY: 3,
          paddingLeft: '92px',
          paddingRight: 3,
          borderRadius: '18px',
          border: `1px solid ${colors.green[30]}`,
          bgcolor: colors.green[20],
          boxShadow: `0 8px 24px ${alpha(colors.green[100], 0.12)}`,
        }}
      >
        <Stack flex={1} minWidth={0}>
          <Typography sx={{ fontSize: 17, fontWeight: 800, color: colors.green[100] }}>{title}</Typography>
          <Typography sx={{ fontSize: 14, color: colors.green[90] }}>{message}</Typography>
        </Stack>
        <IconButton
          aria-label={t('mission.close')}
          onClick={onClose}
          sx={{ flex: 'none', width: 32, height: 32, bgcolor: colors.green[30], color: colors.green[100] }}
        >
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default RewardToast;
